import React from 'react';
import './MenuCarte.css'; // CSS mis à jour

// Données mises à jour avec un champ imageSrc
// !! REMPLACEZ LES NOMS DE FICHIERS PAR VOS VRAIES IMAGES !!
const menuData = [
  {
    id: 1,
    name: "LE PLAISIR SUR MESURE",
    description: "Votre propre sélection de fromages et charcuteries.",
    price: "22,50€",
    details: "/ PERS HORS VIN",
    imageSrc: "/images/g9.jpg" // Chemin vers l'image
  },
  {
    id: 2,
    name: "LA SÉLECTION DE CHEZ PAUL",
    description: "Sélection de chez Paul, fromages et charcuteries.",
    price: "22,50€",
    details: "/ PERS HORS VIN",
    imageSrc: "/images/g10.jpg" // Chemin vers l'image
  },
  {
    id: 3,
    name: "LE PLAISIR DES SENS",
    description: "Dégustation de 6 fromages accordés de 3 vins.",
    price: "29,50€",
    details: "/ PERS",
    imageSrc: "/images/g26.jpg" // Chemin vers l'image
  },
  {
    id: 4,
    name: "L' AUTHENTIQUE RACLETTE",
    description: "Raclette traditionnelle avec la variété de fromage de votre choix, accompagnée de pomme de terre, salade et charcuterie.",
    price: "29,50€",
    details: "/ PERS HORS VIN",
    imageSrc: "/images/g2.jpg" // Chemin vers l'image
  }
];

function MenuCarte() {
  return (
    <section id="carte" className="menu-carte-section">
      <div className="container">
        <div className="menu-header">
          <h2 className="menu-main-title">CHEZ PAUL</h2>
          <h3 className="menu-subtitle">LA CARTE</h3>
        </div>

        <div className="menu-items-list">
          {menuData.map(item => (
            <div key={item.id} className="menu-item">
              {/* Structure modifiée pour inclure l'image */}
              <div className="menu-item-content">
                <div className="menu-item-image-container">
                  <img
                    src={item.imageSrc}
                    alt={item.name}
                    className="menu-item-image"
                    loading="lazy"
                  />
                </div>
                <div className="menu-item-text-details">
                  <h4 className="menu-item-name">{item.name}</h4>
                  <p className="menu-item-description">{item.description}</p>
                </div>
              </div>

              {/* Partie droite: Prix (inchangée) */}
              <div className="menu-item-price-container">
                <span className="menu-item-price">{item.price}</span>
                {item.details && <span className="menu-item-price-details">{item.details}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* La section entière pourrait avoir l'image de la bouteille en fond */}
    </section>
  );
}

export default MenuCarte;